import { render, staticRenderFns } from "./ModulosList.vue?vue&type=template&id=08c4eb1e&"
import script from "./ModulosList.vue?vue&type=script&lang=js&"
export * from "./ModulosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QBtn,QList,QItem,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QToolbarTitle,QSpace,QBtn,QList,QItem,QItemSection,QIcon})
